<template>
  <div class="device-code-page container">
    <img src="@/assets/logos/tree-crossing-logo-160h.png" class="logo" alt="Tree Crossing logo"/>
    <h1>Quick sign in</h1>
    <Spinner v-if="busyRef"/>
    <template v-else-if="approvedRef">
      <img src="@/assets/icons/green_check_circle_64.png" class="status" alt="Success"/>
      <div>
        You should now be signed in to the {{ clientNameRef }}.
      </div>
    </template>
    <div v-else>
      Approval failed :(
    </div>
  </div>
</template>

<style lang="scss" scoped>
.device-code-page {
  padding-top: 6rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  img.logo {
    height: 36px;
  }

  h1 {
    margin: 0 0 3rem;
  }

  img.status {
    margin-bottom: 2rem;
    width: 64px;
  }
}
</style>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTokenManager } from './TokenManager'
import { useTelemetry } from '@/util/Telemetry'
import { LocalTokenApi } from './LocalTokenApi'
import { usePageTitle } from '@/util/AppUtil'
import { addRedactRule } from '@webapp/util/RedactRules'
import Spinner from '@/util/Spinner.vue'

const clientIdArg = 'client_id'
const tokenArg = 'approval_token'

const clientInfos = [
  { id: 'QhHfdp2TGc', name: 'Sync app' },
]

const busyRef = ref(false)
const approvedRef = ref(false)

const route = useRoute()
const router = useRouter()
const tokenManager = useTokenManager()
const { trackException } = useTelemetry()

usePageTitle('Quick sign in')
addRedactRule({ pattern: new RegExp(route.path), params: [tokenArg] })

const clientIdRef = computed(() => route.query[clientIdArg] as string)
const tokenRef = computed(() => route.query[tokenArg] as string)
const clientInfoRef = computed(() => clientInfos.find(n => n.id == clientIdRef.value))
const clientNameRef = computed(() => clientInfoRef.value?.name ?? 'app')

onMounted(async () => {
  approvedRef.value = false

  if (tokenManager.current.isValid) {
    try {
      busyRef.value = true
      await LocalTokenApi.approveDeviceCodeAsync(clientIdRef.value, tokenRef.value, tokenManager.current.token)
      approvedRef.value = true
    }
    catch (error) {
      trackException(error)
    }
    finally {
      busyRef.value = false
    }
  } 
  else {
    // Not signed in yet -- redirect to sign in page
    router.push({ path: '/signin', query: { redirect_uri: `${route.path}?${clientIdArg}=${clientIdRef.value}&${tokenArg}=${tokenRef.value}` } })
  }
})
</script>
